<!--  -->
<template>
  <div>
    <div class="optionbox">
      <div class="optiontext">入口页面：</div>
      <el-select v-model="rukouvalue" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
    <div class="optionbox">
      <div class="optiontext">名称/备注：</div>
      <el-input v-model="name" style="width:300px" placeholder="请输入内容" />
    </div>
    <div class="optionbox">
      <div class="optiontext">推广类型：</div>
      <el-radio-group v-model="linktyperadio">
        <el-radio :label="1">内推</el-radio>
        <el-radio :label="0">外推</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox demo-ruleForm ">
      <div class="optiontext">关注章节序号：</div>
      <el-input v-model="gzinput" style="width:300px" placeholder="请输入内容" type="number" @blur="forcechapterblur" />
    </div>
    <el-button type="primary" @click="sumbit">确定</el-button>
  </div>
</template>

<script>
import { bookPlatformcreate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      objquery: {},
      options: [{
        value: 2,
        label: '小说阅读页'
      }],
      rukouvalue: 2,
      name: '',
      linktyperadio: 1,
      gzinput: ''
    }
  },
  watch: {
    obj: {
      handler(newValue, oldValue) {
        // console.log('111', newValue)
        this.objquery = newValue
        this.name = newValue.bookname + '-' + newValue.chaptername
      },
      deep: true
    }
  },
  created() {
    this.objquery = this.obj
  },
  mounted() {

  },
  methods: {
    forcechapterblur() {
      // eslint-disable-next-line eqeqeq
      if (this.gzinput <= 0 && this.gzinput != '') {
        this.gzinput = 1
      }
      // 判断不能输入小数点
      const str = '' + this.gzinput
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.gzinput = 1
      }
    },
    async sumbit() {
      console.log('this.objquery', this.objquery)
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.objquery.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      if (this.name === '') {
        this.$message.error('请输入名称/备注')
        return
      }
      const data = await bookPlatformcreate({
        platform_id: this.objquery.platformvalue,
        template_data: {
          entrance_type: this.rukouvalue,
          novel_id: this.objquery.bookid,
          paragraph_id: this.objquery.chapterid,
          order_num: this.objquery.chapteridx,
          remark: this.name,
          push_type: this.linktyperadio,
          freely_qrcode: this.gzinput,
          chapter_name: this.objquery.chaptername
        }
      })
      this.$emit('close')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      console.log('data', data)
      // console.log(' this.chaunarr', this.chaunarr)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.optionbox{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext{
  width: 100px;
  text-align: right;
}
.loltext{
  margin-left: 100px;
}
.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
